import { lazy } from 'react'

export const KitCancelOfferQuestionV1 = lazy(
  () => import('./kitV1/KitCancelOfferQuestionV1'),
)
